import notifiesService from "../../services/notifies.service";


const state = {

    NotificationList : []

};

const mutations = {
    set_notifications(state,payload)
    {
        state.NotificationList =payload;
    },

    clear_notifications(state)
    {
        state.NotificationList=[]
    }

};

const actions = {
    async getNotifications({commit})
    {
        await commit("clear_notifications");
        const notifications = await notifiesService.GetNotifications();
        await commit("set_notifications",notifications);
        return notifications;

    },
};

export default
{
    namespaced: true,
    state,
    mutations,
    actions,
}
